/* Copyright (c) 2018 Scaper */

export const ABOUT_US_PATH = "/about-us";
